import React from "react";
import assign from "lodash/assign";
import throttle from "lodash/throttle";
import {
  FlatButton,
  DropDownMenu,
  TextField,
  MenuItem,
  Toggle,
  RaisedButton
} from "material-ui";
import Tag from "../tag.jsx";

import TicketStore from "../../../stores/TicketStore";
import WishlistStore from "../../../stores/WishlistStore";
import WishlistActions from "../../../actions/WishlistActions";

class EventFilterEditor extends React.Component {
  constructor(props) {
    super(props);

    this.close = this.close.bind(this);
    this.open = this.open.bind(this);

    this._onSearchChange = throttle(this._onSearchChange.bind(this), 100);
  }

  static contextTypes = {
    appSettings: React.PropTypes.object
  };

  _onSearchChange(e) {
    this.props.onSearchChange(e);
  }

  getStyles() {
    return {
      main: {
        margin: "20px auto 10px",
        padding: "1em 2em 1.5em",
        position: "relative",
        lineHeight: "2.3",
        boxShadow: "0 0 2.1rem rgba(69, 77, 93, 0.25)",
        borderRadius: "10px",
        maxWidth: "90vw",
        boxSizing: "border-box",
        backgroundColor: "#fff"
      },
      close: {
        position: "absolute",
        cursor: "pointer",
        fontWeight: 700,
        fontSize: "1.5em",
        top: 0,
        right: "0.9em"
      },
      openContainer: {
        textAlign: "center",
        margin: "10px",
        whiteSpace: "nowrap" // prevent line break between dropdown and filter button on small width
      },
      openContainerLarge: {
        textAlign: "right"
      },
      viewModeContainer: {
        display: "inline-block",
        textAlign: "left"
      },
      viewModeContainerLarge: {
        marginLeft: -24
      },
      openButtonContainer: {
        display: "inline-block"
      },
      filterButton: {
        boxSizing: "content-box",
        border: "1px solid"
      },
      mineContainer: {
        margin: "10px auto 0",
        textAlign: "center"
      },
      mineContainerLarge: {
        textAlign: "right"
      },
      label: {
        fontSize: "0.9em",
        color: "#606060",
        marginRight: 8
      },
      menuItem: {
        cursor: "pointer",
        color: "rgb(33,33,33)"
      }
    };
  }

  close() {
    this.props.onClose();
  }

  open() {
    this.props.onOpen();
  }

  render() {
    let { events, tags, venues, isLarge } = this.props,
      styles = this.getStyles();

    let tagComponents = tags
      .filter(tag => typeof tag.visible !== "undefined" ? tag.visible : true)
      .map(t => (
        <Tag
          content={t}
          key={t.id}
          checkable={true}
          disabled={!this.props.filterTags[t.id]}
          style={{ display: "inline-block", whiteSpace: "nowrap" }}
          onClick={() => {
            this.props.onTagChange(t.id, !this.props.filterTags[t.id]);
          }}
        />
      ));

    let venueComponents = venues.map(v => (
      <Tag
        content={v}
        key={v.id}
        checkable={true}
        disabled={!this.props.filterVenues[v.id]}
        style={{ display: "inline-block", whiteSpace: "nowrap" }}
        onClick={() => {
          this.props.onFilterVenueChange(v.id, !this.props.filterVenues[v.id]);
        }}
      />
    ));

    let viewModes = [
      <MenuItem
        style={styles.menuItem}
        key={0}
        primaryText={"Compact view"}
        value={"compact"}
      />,
      <MenuItem
        style={styles.menuItem}
        key={1}
        primaryText={"Extended view"}
        value={"extended"}
      />,
      <MenuItem
        style={styles.menuItem}
        key={2}
        primaryText={"Grid view"}
        value={"grid"}
      />,
      <MenuItem
        style={styles.menuItem}
        key={3}
        primaryText={"Cover view"}
        value={"cover"}
      />,
      <MenuItem
        style={styles.menuItem}
        key={4}
        primaryText={"Timeline view"}
        value={"timeline"}
      />
    ];

    let viewModeSelect = (
      <DropDownMenu
        autoWidth={false}
        style={{ width: 192 }}
        labelStyle={{ overflow: "visible" }}
        value={this.props.viewMode}
        onChange={(e, index, selected) => {
          this.props.onViewModeChange(selected);
        }}
      >
        {viewModes}
      </DropDownMenu>
    );

    let eventViewSelect = this.props.includeEventViewFilter ? (
      <DropDownMenu
        autoWidth={false}
        style={{ width: 225 }}
        labelStyle={{ overflow: "visible" }}
        value={this.props.eventViewFilter}
        onChange={(e, index, selected) => {
          this.props.onEventViewFilterChange(selected);
        }}
      >
        <MenuItem
          style={styles.menuItem}
          key={0}
          primaryText={"Physical only"}
          value={"physical"}
        />
        <MenuItem
          style={styles.menuItem}
          key={1}
          primaryText={"Virtual only"}
          value={"virtual"}
        />
        <MenuItem
          style={styles.menuItem}
          key={2}
          primaryText={"Physical & Virtual"}
          value={"hybrid"}
        />
      </DropDownMenu>
    ) : null;

    let hasWishlist = this.props.hasWishlist,
      hasTickets =
        Object.keys(events).some(
          e => events[e].person && events[e].person.ticket_count > 0
        ) || TicketStore.getTickets().length,
      hasWishlistAndTickets = hasWishlist && hasTickets,
      unticketedWishlistEvents = WishlistStore.getUnticketedWishlistEvents();

    let justMyEventsControl =
      this.props.justMyEvents || hasWishlist || hasTickets ? (
        <div>
          <Toggle
            label={
              hasWishlistAndTickets
                ? "Only show my tickets & starred events"
                : hasTickets
                ? "Only show my tickets"
                : "Only show starred events"
            }
            labelPosition="right"
            style={{ width: "auto", display: "inline-block" }}
            toggled={this.props.justMyEvents}
            onToggle={(e, toggled) => this.props.onJustMyEventsChange(toggled)}
          />
          {this.context.appSettings.enable_order_all_starred &&
          this.context.appSettings.standalone_ticket_sales_enabled &&
          this.props.justMyEvents &&
          unticketedWishlistEvents.length > 0 ? (
            <div style={{ marginTop: 10 }}>
              <RaisedButton
                primary={true}
                style={{ display: "inline-block", margin: "0 auto" }}
                label={
                  <span style={{}}>{`Order tickets to ${
                    unticketedWishlistEvents.length
                  } starred event${
                    unticketedWishlistEvents.length === 1 ? "" : "s"
                  }`}</span>
                }
                onClick={WishlistActions.orderUnticketed}
              />
            </div>
          ) : null}
        </div>
      ) : null;

    return this.props.open ? (
      <div style={styles.main}>
        <div style={styles.close} onClick={this.close}>
          ×
        </div>
        <div>
          <div style={{ marginBottom: "-0.5em" }}>
            <span style={styles.label}>Search by event name/description: </span>
            <TextField
              name="search"
              defaultValue={this.props.search}
              onChange={e => {
                e.persist();
                this._onSearchChange(e);
              }}
            />
          </div>
          {venueComponents.length ? (
            <div style={{ marginTop: "0.5em" }}>
              <span style={styles.label}>Filter by venue:</span>
              <div style={{ marginTop: "-0.5em", lineHeight: 1 }}>
                {venueComponents}
              </div>
            </div>
          ) : null}
          {tagComponents.length ? (
            <div style={{ marginTop: "0.5em" }}>
              <span style={styles.label}>Filter by tag:</span>
              <div style={{ marginTop: "-0.5em", lineHeight: 1 }}>
                {tagComponents}
              </div>
            </div>
          ) : null}
          {eventViewSelect ? (
            <div>
              <span style={assign({}, styles.label)}>Event types: </span>
              <span style={{ marginLeft: -24 }}>{eventViewSelect}</span>
            </div>
          ) : null}
          <div>
            <span style={assign({}, styles.label)}>View mode: </span>
            <span style={{ marginLeft: -24 }}>{viewModeSelect}</span>
          </div>
          {justMyEventsControl ? (
            <div style={{ marginTop: 10 }}>
              <div style={styles.label}>Additional controls</div>
              {justMyEventsControl}
            </div>
          ) : null}
        </div>
      </div>
    ) : (
      <div
        style={assign(
          {},
          styles.openContainer,
          isLarge && styles.openContainerLarge
        )}
      >
        <div
          style={assign(
            {},
            styles.viewModeContainer,
            !isLarge && styles.viewModeContainerLarge
          )}
        >
          {viewModeSelect}
        </div>
        <div
          style={assign(
            {},
            styles.openButtonContainer,
            isLarge && styles.openButtonContainerLarge
          )}
        >
          <FlatButton
            primary={true}
            label={
              <span style={{ verticalAlign: 1 }}>
                <span className="icon-search"></span> Filter events...
              </span>
            }
            style={styles.filterButton}
            onClick={this.open}
          />
        </div>
        <div
          style={assign(
            {},
            styles.mineContainer,
            isLarge && styles.mineContainerLarge
          )}
        >
          {justMyEventsControl}
        </div>
      </div>
    );
  }
}

export default EventFilterEditor;



// WEBPACK FOOTER //
// ./src/app/components/partials/event-list/event-filter-editor.jsx